import { Balance } from "@elrondnetwork/erdjs/out";
import { LeaderboardEntryType } from "context/state";
import downloadFile from "helpers/downloadFile";
import extractValues from "./LeaderRow/extractValues";

const getBalance = (balance: string) => {
  return Balance.fromString(balance).toDenominated();
};

export default function download(
  data: LeaderboardEntryType[],
  timestamp: string,
) {
  const header = [
    "Rank",
    "Address",
    "Total Value",

    "MEX Farm",
    "MEX Farm Value",
    "EGLD-MEX Farm",
    "EGLD-MEX Farm Value",
    "EGLD-BUSD Farm",
    "EGLD-BUSD Farm Value",

    "EGLD",
    "EGLD Value",
    "MEX",
    "MEX Value",
    "LKMEX",
    "LKMEX Value",

    "BUSD",
    "BUSD Value",

    "EGLD-BUSD LP",
    "EGLD-BUSD LP Value",
    "EGLD-MEX LP",
    "EGLD-MEX LP Value",

    "Nonce",
  ];
  const csvData = [header.join(",")];
  data.forEach((props, i: number) => {
    const {
      BUSD,
      MEX,
      EGLDBUSD,
      LKMEX,
      EGLDMEX,
      MEXFARM,
      EGLDMEXF,
      EGLDBUSDF,
    } = extractValues(props);

    const EGLD = {
      valueUSD: props.balanceUSD,
      balance: props.balance,
    };

    const csvRow = [
      i + 1, // rank
      props.address,
      props.netWorth,
      getBalance(MEXFARM.balance),
      MEXFARM.valueUSD,

      getBalance(EGLDMEXF.balance),
      EGLDMEXF.valueUSD,

      getBalance(EGLDBUSDF.balance),
      EGLDBUSDF.valueUSD,

      getBalance(EGLD.balance),
      EGLD.valueUSD,

      getBalance(MEX?.balance ?? "0"),
      MEX?.valueUSD,

      getBalance(LKMEX.balance),
      LKMEX.valueUSD,

      getBalance(BUSD?.balance ?? "0"),
      BUSD?.valueUSD,

      getBalance(EGLDBUSD?.balance ?? "0"),
      EGLDBUSD?.valueUSD,

      getBalance(EGLDMEX?.balance ?? "0"),
      EGLDMEX?.valueUSD,

      props.nonce,
    ];

    csvData.push(csvRow.join(","));
  });

  downloadFile({
    data: csvData.join("\n"),
    name: `Mex Leaderboard ${timestamp}`,
    fileType: "csv",
  });
}
